<template>
  <div class="score_wrap">
    <div style="text-align:center">
      <el-form :model="formData" ref="formData" class="demo-form-inline">
        <div class="score_search">
          <div>
            <el-form-item prop="cityId" class="lab_icon lab">
              <el-select placeholder="请输入城市" @change="onCityChange" v-model="formData.cityId">
                <el-option
                  :key="option.id"
                  v-for="option in cityOptions"
                  :title="option.name"
                  :value="option.id"
                  :label="option.name"
                >{{option.name}}</el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="examNo">
              <el-input placeholder="考生准考证号或身份证号或护照号" v-model="formData.examNo" class="examNo_ID"></el-input>
            </el-form-item>
          </div>
          <div style="padding-left: 20px">
            <el-form-item>
              <el-button type="primary" @click="seachScore()">搜索</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="container" v-show="isShow">
        <el-table :data="tableData" stripe style="width: 100%" >
          <el-table-column prop="examNo" label="准考证" align='center' min-width='100px'></el-table-column>
          <el-table-column prop="name" label="考生姓名" align='center'></el-table-column>
          <el-table-column label="专业级别" align='center'>
            <template slot-scope="scope">
              <div>
                <span>{{scope.row.subjectName}}&nbsp;&nbsp;{{scope.row.subjectRank}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="辅导课" align='center'></el-table-column>
          <el-table-column prop="subjectScore" label="器乐成绩" align='center'></el-table-column>
          <el-table-column prop="theoryScore" label="乐理成绩" align='center'></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        cityId: "",
        examNo: ""
      },
      tableData: [],
      // rules: {
      //   cityId: [{ required: true, message: "城市不能为空", trigger: "blur" }],
      //   examNo: [
      //     { required: true, message: "准考证号不能为空", trigger: "blur" }
      //   ]
      // },
      isShow: false,
      cityOptions: []
    };
  },
  created() {
    this.getCity();
  },
  methods: {
    getCity() {
      let that = this;
      window.Global.get(
        "/city/getCityDown",
        { id: "1269f17c26ab4e1da890acc187399911" },
        rs => {
          console.log(rs);
          if (rs.status == 200) {
            that.cityOptions = rs.data.result;
            console.log(that.cityOptions);
          }
        }
      );
    },
    onCityChange(value) {
      console.log(value);
      this.formData.cityId = value;
    },
    seachScore() {
      let that = this;
      let flag = true;
      if (this.formData.cityId&&this.formData.examNo) {
        flag = true;
      } else {
        flag = false;
      }
      if (flag) {
        window.Global.get(
          "/examEasy/list",
          {
            examNo: this.formData.examNo,
            cityId: this.formData.cityId
          },
          rs => {
            if (rs.data.status == 200) {
              that.tableData = rs.data.result.result.data;
              that.isShow = true;
            } else {
            }
          }
        );
      } else {
        that.$message.error("请完善查询信息");
      }
    }
    // seachScore(formData) {
    //   let that = this;
    //   this.$refs[formData].validate(valid => {
    //     console.log(111);
    //     if (valid) {
    //       console.log(1234567890876543456);
    //       window.Global.get("/examEasy/list",
    //         {
    //           examNo: this.formData.examNo,
    //           cityId: this.formData.cityId
    //         },rs => {
    //           console.log(222222222, rs);
    //           if (rs.data.status == 200) {
    //             that.formData.data = rs.data.result.result.data;
    //             console.log(rs.data.result.result);
    //             that.isShow = true;
    //           } else {
    //           }
    //         }
    //       );
    //     } else {
    //       that.$message.error("请完善查询信息");
    //     }
    //   });
    // }
  }
};
</script>
<style lang="less">
.score_wrap{
  .score_search {
  display: flex;
  justify-content: center;
  .el-input {
    width: 90%;
    .el-input__inner {
      padding: 10px 10px;
    }
  }
  .examNo_ID .el-input__inner{
    width: 250px;
    margin-right: 20px; 
  }
}
.container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.el-button--primary{
  height: 30px;
  line-height: 0;
}
}

</style>


// WEBPACK FOOTER //
// src/components/score.vue